var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedLineServices3Outline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.1997C13.5523 14.1997 14 13.752 14 13.1997C14 12.6474 13.5523 12.1997 13 12.1997C12.4477 12.1997 12 12.6474 12 13.1997C12 13.752 12.4477 14.1997 13 14.1997Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17C14 17.5523 13.5523 18 13 18C12.4477 18 12 17.5523 12 17C12 16.4477 12.4477 16 13 16C13.5523 16 14 16.4477 14 17Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.1997C17.5523 14.1997 18 13.752 18 13.1997C18 12.6474 17.5523 12.1997 17 12.1997C16.4477 12.1997 16 12.6474 16 13.1997C16 13.752 16.4477 14.1997 17 14.1997Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10H16.9945C17.5468 10 17.9945 9.55228 17.9945 9C17.9945 8.44772 17.5468 8 16.9945 8H13Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H8C9.10457 2 10 2.89543 10 4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H6C4.61619 22 3.45122 21.0631 3.10483 19.789C2.44969 19.4605 2 18.7828 2 18V4ZM10 18V6H19C19.5523 6 20 6.44772 20 7V19C20 19.5523 19.5523 20 19 20H8C9.10457 20 10 19.1046 10 18ZM8 4H4V18H8V4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedLineServices3Outline2);
export default __webpack_public_path__ + "static/media/fixed-line-services-3_outline (2).2ce8f57ff8441fd04f1f2a1d2176d01f.svg";
export { ForwardRef as ReactComponent };